import { handleAction } from 'redux-actions';

import { PLANS_FETCHED } from 'app/features/plans/actionTypes';
import { pickPayload } from 'app/reducers/helpers';

const plans = handleAction(PLANS_FETCHED, pickPayload, {});

export default plans;
